import React from 'react';
import { NavLink } from 'react-router-dom';
import { useWeb3 } from '../../context/Web3Context';

const NAV = [
  { to: '/dashboard', label: 'Dashboard', icon: '◆' },
  { to: '/invest', label: 'Invest', icon: '↑' },
  { to: '/my-investments', label: 'My Stakes', icon: '◐' },
  { to: '/rewards', label: 'Rewards', icon: '★' },
  { to: '/team', label: 'Team', icon: '⚏' },
  { to: '/profile', label: 'Profile', icon: '◉' }
];

const Sidebar = ({ open, onClose }) => {
  const { isPrivileged } = useWeb3();

  return (
    <>
      <div
        className={`sidebar-overlay ${open ? 'open' : ''}`}
        onClick={onClose}
      />
      <aside className={`sidebar ${open ? 'open' : ''}`}>
        <nav className="sidebar-nav">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
              onClick={onClose}
            >
              <span className="nav-icon">{item.icon}</span>
              <span className="nav-link-label">{item.label}</span>
            </NavLink>
          ))}

          {isPrivileged && (
            <>
              <div style={{
                margin: '20px 16px 8px',
                fontSize: 10,
                letterSpacing: '0.2em',
                color: 'var(--text-muted)',
                fontFamily: 'Orbitron, sans-serif',
                textTransform: 'uppercase'
              }}>Control</div>
              <NavLink
                to="/admin"
                className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                onClick={onClose}
                style={{ color: 'var(--accent-purple)' }}
              >
                <span className="nav-icon">⚙</span>
                <span className="nav-link-label">Admin Panel</span>
              </NavLink>
            </>
          )}
        </nav>
      </aside>
    </>
  );
};

export default Sidebar;
